import { assertFailed, assertNot } from "@dataspecer/core/core";
import { DataSpecificationSchema, } from "@dataspecer/core/data-specification/model";
import { defaultStructureTransformations, structureModelTransformCodelists, transformStructureModel } from "@dataspecer/core/structure-model/transformation";
import { structureModelAddXmlProperties } from "../xml-structure-model/add-xml-properties.js";
import { structureModelToXmlSchema } from "./xml-schema-model-adapter.js";
import { XML_SCHEMA } from "./xml-schema-vocabulary.js";
import { writeXmlSchema } from "./xml-schema-writer.js";
import { XmlSchemaDocumentationGenerator } from "../documentation/xml-schema-documentation.js";
export const NEW_DOC_GENERATOR = "https://schemas.dataspecer.com/generator/template-artifact";
export class XmlSchemaGenerator {
    identifier() {
        return XML_SCHEMA.Generator;
    }
    async generateToStream(context, artefact, specification, output) {
        const { xmlSchema: model } = await this.generateToObject(context, artefact, specification);
        const stream = output.writePath(artefact.outputPath);
        await writeXmlSchema(model, stream);
        await stream.close();
    }
    async generateToObject(context, artefact, specification) {
        if (!DataSpecificationSchema.is(artefact)) {
            assertFailed("Invalid artefact type.");
        }
        const schemaArtefact = artefact;
        const conceptualModel = context.conceptualModels[specification.pim];
        assertNot(conceptualModel === undefined, `Missing conceptual model ${specification.pim}.`);
        let model = context.structureModels[schemaArtefact.psm];
        assertNot(model === undefined, `Missing structure model ${schemaArtefact.psm}.`);
        const transformations = defaultStructureTransformations;
        model = transformStructureModel(conceptualModel, model, Object.values(context.specifications), null, transformations);
        model = structureModelTransformCodelists(model);
        const xmlModel = await structureModelAddXmlProperties(model, context.reader);
        return {
            xmlSchema: await structureModelToXmlSchema(context, specification, schemaArtefact, xmlModel),
            conceptualModel,
        };
    }
    async generateForDocumentation(context, artefact, specification, documentationIdentifier, callerContext) {
        if (documentationIdentifier === NEW_DOC_GENERATOR) {
            const { artifact: documentationArtefact, partial, adapter } = callerContext;
            const { xmlSchema, conceptualModel } = await this.generateToObject(context, artefact, specification);
            const generator = new XmlSchemaDocumentationGenerator(documentationArtefact, xmlSchema, conceptualModel, context, artefact, specification, partial, adapter);
            return generator.generateToObject();
        }
        return null;
    }
}
//# sourceMappingURL=xml-schema-generator.js.map